import * as React from 'react';
import { Box, Card, SxProps } from '@mui/material';
import { CardHeader } from '../../atoms';
import { AdaptiveActionBar } from './fragments/AdaptativeActionBar';
import { type ActionConfig } from './hooks/useAdaptiveActions';

export type ActivityHistoryCardProps = {
    /** Titre de la carte */
    title?: string;
    sx?: SxProps;
    actions?: ActionConfig[];
};

/**
 * Composant carte d'historique d'activités avec filtrage et actions
 */
export const ActivityHistoryCard: React.FunctionComponent<
    React.PropsWithChildren<ActivityHistoryCardProps>
> = function ({ children, actions, sx, title = "Historique d'activités" }) {
    return (
        <Card
            sx={{
                paddingLeft: '0px',
                mx: 0,
                ...sx,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                    paddingTop: '16px',
                    paddingBottom: '16px',
                }}
            >
                <CardHeader
                    title={title}
                    headerSx={{ paddingTop: '0px' }}
                />
                {actions && actions.length > 0 && (
                    <Box
                        sx={{
                            width: '500px',
                            flexShrink: 0,
                            marginRight: 2,
                            overflow: 'hidden',
                        }}
                    >
                        <AdaptiveActionBar actions={actions} />
                    </Box>
                )}
            </Box>
            {children}
        </Card>
    );
};
